import { render } from "./CardList.vue?vue&type=template&id=e5ca296e&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=e5ca296e&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5ca296e"]])

export default __exports__